module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"amo":{"account-title":"Account amoCRM"}},"ua":{"amo":{"account-title":"Акаунт amoCRM"}},"ru":{"amo":{"account-title":"Аккаунт amoCRM"}}}')
  delete Component.options._Ctor
}
